import { render, staticRenderFns } from "./RecommendedOfferRecapTile.vue?vue&type=template&id=63cfd07c&scoped=true&"
import script from "./RecommendedOfferRecapTile.vue?vue&type=script&lang=js&"
export * from "./RecommendedOfferRecapTile.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedOfferRecapTile.vue?vue&type=style&index=0&id=63cfd07c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cfd07c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63cfd07c')) {
      api.createRecord('63cfd07c', component.options)
    } else {
      api.reload('63cfd07c', component.options)
    }
    module.hot.accept("./RecommendedOfferRecapTile.vue?vue&type=template&id=63cfd07c&scoped=true&", function () {
      api.rerender('63cfd07c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/orange/broadband/demands/showcase/internetandmobileoffers/components/RecommendedOfferRecapTile.vue"
export default component.exports